module.exports = __webpack_public_path__ + "media/images/fbcalls/banner_topo-8676270804db62f1bd7644418db801d8.jpg";